import pImg1 from 'assets/images/products/48/img-1.png';
import pImg3 from "assets/images/products/48/img-3.png";
import pImg6 from "assets/images/products/48/img-6.png";
import pImg9 from "assets/images/products/48/img-9.png";
import pImg2 from "assets/images/products/48/img-2.png";

const shopingdata = [
    {
        id: 1,
        img: pImg1,
        title: "Branded T-Shirts",
        category: "Fashion",
        size: "XL",
        color: "Blue",
        price: 161.25,
        num: 1,
        Total: 161.25,
    },
    {
        id: 2,
        img: pImg3,
        title: "Fossil gen 5E smart watch",
        category: "Watchs",
        color: "White",
        price: 69.60,
        Total: 69.60,
        num: 1,
    },
    {
        id: 3,
        img: pImg6,
        title: "Olive Printed Men Round Neck",
        category: "Fashion",
        size: "M",
        color: "Brown",
        price: 250.00,
        Total: 250.00,
        num: 1,
    },
    {
        id: 4,
        img: pImg9,
        title: "Flip-Flops and House Slippers",
        category: "Footwear",
        size: "8",
        color: "Green",
        price: 150.00,
        Total: 150.00,
        num: 1,
    },
    {
        id: 5,
        img: pImg2,
        title: "Like style travel black handbag",
        category: "Luggage",
        color: "Green",
        price: 89.99,
        Total: 89.99,
        num: 1,
    },
];

const chooseShoppingAdd = [
    {
        id: 1,
        selectadd: 'Home',
        name: 'Kiara Corkery',
        address: '912 Park Ave, Ketchikan, Alaska 99901, USA',
        contact: '(907) 826-3317',
    },
    {
        id: 2,
        selectadd: 'Office',
        name: 'Jarrett Rempel',
        address: '2566 Hc 1, Glennallen, Alaska 99588, USA',
        contact: '(907) 225-9273',
    },
]

export { shopingdata, chooseShoppingAdd };
